// extracted by mini-css-extract-plugin
export default {"nav":"CustomerNav_nav__qRkBl","leftControls":"CustomerNav_leftControls__uwgiY","rightSec":"CustomerNav_rightSec__Pe0ON"};